import React from 'react';
import { Hero } from '@components/Hero/index';

const Masthead = ({
  full = false,
  modifier = '',
  job,
  title,
  isBackToJobAvailable,
  isBackToHomepageAvailable,
  children,
}) => {
  return (
    <div
      className={`c-app-masthead ${
        full ? 'c-app-masthead--primary-single-tint' : ''
      } ${modifier}`}
    >
      <div className="rev-o-container rev-o-container--full">
        <div className="rev-o-grid">
          <div className="rev-o-col-12 c-app-masthead__background">
            <div className="rev-o-container">
              <div className="rev-o-grid">
                <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-9 c-app-masthead__primary">
                  <Hero
                    isBackToHomepageAvailable={isBackToHomepageAvailable}
                    isBackToJobAvailable={isBackToJobAvailable}
                    title={title ? title : job.title}
                  />
                  {children && children.left ? children.left : null}
                </div>
                {!full ? (
                  <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-3 c-app-masthead__secondary">
                    {children && children.right ? children.right : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Masthead;
